/** @jsxImportSource @emotion/react */

import { RatingStarsAnimated } from '@stories/atoms/RatingStars';
import { headlines } from '@stories/templates/VitafyAboutUsPage/VitafyAboutUsPage';
import { media, mq } from '@stories/theming/settings';

import AdCarousel from '../AdCarousel/AdCarousel';

import type { IAdCarouselProps } from '../AdCarousel/AdCarousel';
import type { TTrustedShopsRatingResponse } from '@vitafy/storefront-api-contracts';

export type AdCarouselWithTextProps = {
  headline: string;
  etrustedData?: TTrustedShopsRatingResponse | null;
} & IAdCarouselProps;

export const AdCarouselWithText: React.FC<AdCarouselWithTextProps> = ({
  adSlides,
  ratio,
  headline,
  etrustedData
}) => {
  return (
    <div css={{ position: 'relative' }}>
      <AdCarousel adSlides={adSlides} ratio={ratio} />
      <div
        css={{
          fontSize: '20px',
          padding: '1rem var(--offset)',
          textAlign: 'center',
          [media('desktop')]: {
            color: 'white',
            fontSize: '26px',
            left: '50%',
            maxWidth: '45rem',
            position: 'absolute',
            top: '50%',
            transform: 'translate(-50%, -50%)'
          }
        }}
      >
        <h1 css={{ ...headlines.h1 }}>{headline}</h1>
        <div
          css={mq({
            margin: 'auto',
            marginTop: ['1rem', null, '3rem'],
            maxWidth: '20rem'
          })}
        >
          <RatingStarsAnimated
            ratingAverage={etrustedData?.aggregateRating?.rating || 4.65}
            starsWidth={2.25}
          />
          <div
            css={mq({
              fontWeight: [400],
              lineHeight: '1.4',
              marginTop: '.25rem'
            })}
          >
            Über {Intl.NumberFormat('de-DE').format(etrustedData?.aggregateRatingTotal.count || 32834)}{' '}
            verifizierte Bewertungen
          </div>
        </div>
      </div>
    </div>
  );
};
